/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_TitleInputs */

const en_svc_messaging_bots_title = /** @type {(inputs: Svc_Messaging_Bots_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp, Telegram and Messenger Bots`)
};

const ar_svc_messaging_bots_title = /** @type {(inputs: Svc_Messaging_Bots_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بوتات واتساب وتيليغرام وماسنجر`)
};

const bn_svc_messaging_bots_title = /** @type {(inputs: Svc_Messaging_Bots_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হোয়াটসঅ্যাপ, টেলিগ্রাম ও মেসেঞ্জার বট`)
};

const de_svc_messaging_bots_title = /** @type {(inputs: Svc_Messaging_Bots_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp-, Telegram- und Messenger-Bots`)
};

const es_svc_messaging_bots_title = /** @type {(inputs: Svc_Messaging_Bots_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bots de WhatsApp, Telegram y Messenger`)
};

const fr_svc_messaging_bots_title = /** @type {(inputs: Svc_Messaging_Bots_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bots WhatsApp, Telegram et Messenger`)
};

const pt_svc_messaging_bots_title = /** @type {(inputs: Svc_Messaging_Bots_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bots de WhatsApp, Telegram e Messenger`)
};

const zh_svc_messaging_bots_title = /** @type {(inputs: Svc_Messaging_Bots_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp、Telegram 和 Messenger 机器人`)
};

const tr_svc_messaging_bots_title = /** @type {(inputs: Svc_Messaging_Bots_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp, Telegram ve Messenger Botları`)
};

const ru_svc_messaging_bots_title = /** @type {(inputs: Svc_Messaging_Bots_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Боты WhatsApp, Telegram и Messenger`)
};

const pl_svc_messaging_bots_title = /** @type {(inputs: Svc_Messaging_Bots_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boty WhatsApp, Telegram i Messenger`)
};

/**
* | output |
* | --- |
* | "WhatsApp, Telegram and Messenger Bots" |
*
* @param {Svc_Messaging_Bots_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_title = /** @type {((inputs?: Svc_Messaging_Bots_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_title(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_title(inputs)
	if (locale === "de") return de_svc_messaging_bots_title(inputs)
	if (locale === "es") return es_svc_messaging_bots_title(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_title(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_title(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_title(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_title(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_title(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_title(inputs)
	return en_svc_messaging_bots_title(inputs)
});
export { svc_messaging_bots_title as "svc_messaging-bots_title" }